import { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import AccountModel from "../Models/Account/AccountModel";
import "./Layout/Layout.scss";
import { LoadingView } from "./Layout/Loading/LoadingView";
import { SSModal } from "./Layout/Modal/SSModal";
import Router from "./Routers/Router";
import RouterLoggedOut from "./Routers/RouterLoggedOut";

import { ToastRoot } from "../Components/Toast/ToastRoot";
import { VoiceCallBar } from "../Components/VoiceCallBar/VoiceCallBar";



function App() {
  // Test error to verify Sentry installation.
  // useEffect(() => {
  //   SwivlException.throwTestError();
  // }, []);

  const { account, member, accountLoaded, accountIsLoading } = AccountModel.useState((s) => s);

  useEffect(() => {
    AccountModel.loadAccount();
    if (localStorage.getItem("debugSet") !== "true") {
      localStorage.setItem("debugSet", "true");
      localStorage.setItem("debug", "error:*, warn:*, info:*, debug:*, notifications:*,users:*");


      // Uncomment the line below to enable debug mode in development
      // localStorage.set("debugSet", "true");
    }
  }, []);

  if (!accountLoaded || accountIsLoading) {
    return (
      <div className="App">
        <LoadingView />
      </div>
    );
  }

  return (
    <>
      <BrowserRouter>{!member ? <RouterLoggedOut account={account} /> : <Router />}
        <ToastRoot account={account} />
        <VoiceCallBar />
      </BrowserRouter>
      <ToastContainer />
      <SSModal />
    </>
  );
}

export default App;
